export enum FilterSelectorTypes {
  Dropdown = 1,
  Single_Checkbox = 2,
  Multiple_Checkboxes = 3,
  Date = 4,
}
